import {
  ChartMark,
  WidgetKind,
  type Metric,
  type MetricLike,
  type Report,
  type WidgetOf,
} from 'corso-admin-ui';
import { productRows } from './claimItems';

type Kpi = Extract<WidgetOf<'orderItems'>, { kind: typeof WidgetKind.kpi }>;

export const rateReport = <
  const Finalized extends Metric<'orderItems'>,
  const Rate extends MetricLike<'orderItems', { format: 'percent' }>,
>({
  finalized,
  rate,
  chart,
  tables,
}: {
  finalized: { metric: Finalized; title?: string };
  rate: Kpi & { metric: Rate; format?: never };
  chart: { title: string; description: string };
  // the tables list the products with the most items finalized, not the highest rates
  tables: { products: string; variants: string; rankedBy: string };
}) =>
  ({
    key: 'rate',
    label: 'Rate',
    dataset: 'orderItems',
    timeFields: ['createdOn'],
    widgets: [
      {
        kind: WidgetKind.kpi,
        description: 'On orders placed in this period',
        metric: 'itemsSold',
      },
      {
        ...finalized,
        kind: WidgetKind.kpi,
        description: 'Of those items, approved or denied so far',
      },
      rate,
      {
        ...chart,
        kind: WidgetKind.overTime,
        mark: ChartMark.line,
        metrics: [rate.metric],
      },
      {
        kind: WidgetKind.table,
        title: tables.products,
        description: `The ${productRows} products with the most ${tables.rankedBy}`,
        dimensions: ['productTitle'],
        metrics: [finalized.metric, 'itemsSold', rate.metric],
        limit: productRows,
      },
      {
        kind: WidgetKind.table,
        title: tables.variants,
        description: `The ${productRows} variants with the most ${tables.rankedBy}`,
        dimensions: ['productTitle', 'variantTitle'],
        metrics: [finalized.metric, 'itemsSold', rate.metric],
        limit: productRows,
      },
    ],
  }) as const satisfies Report;
